<template>
  <div class="col-12 p-0 text-center">
    <div class="logo-live" v-bind:class="{ tiny: tiny, 'no-bg': no_bg }">
      <img data-part="1" src="../assets/image/nicard-logo-part-1.png" />
      <img data-part="2" src="../assets/image/nicard-logo-part-2.png" />
      <img data-part="3" src="../assets/image/nicard-logo-part-3.png" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tiny: Boolean,
    no_bg: Boolean
  }
};
</script>
<style scoped>
.logo-live {
  position: relative;
  width: 100px;
  height: 100px;
  overflow: hidden;
  background: #f8f8f8;
  margin: 0 auto;
}

.logo-live img {
  position: absolute;
  animation-duration: 1.5s;
  max-width: 100px;
  bottom: 0px;
}

.logo-live img[data-part="1"] {
  animation-name: logo-live-step-one;
  left: 0px;
}

.logo-live img[data-part="2"] {
  animation-name: logo-live-step-two;
  right: 0px;
}

.logo-live img[data-part="3"] {
  animation-name: logo-live-step-three;
  left: 0px;
}

.logo-live.no-bg {
  background: unset;
}

.logo-live.tiny {
  width: 50px;
  height: 40px;
}

.logo-live.tiny img {
  animation-duration: 1s;
  max-width: 50px;
}

@keyframes logo-live-step-one {
  from {
    left: -100%;
  }

  to {
    left: 0px;
  }
}

@keyframes logo-live-step-two {
  from {
    right: -100%;
  }

  to {
    right: 0px;
  }
}

@keyframes logo-live-step-three {
  from {
    bottom: -100%;
  }

  to {
    bottom: 0px;
  }
}
</style>
